import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {ErrorToaster} from "../../../../shared/toaster";
import '../log.css'
import {LoadingState} from "../../../../components/fouladyar/loading-state/loadingState";

const OpenPositions = () => {
    const auth = useSelector((state) => state.auth);
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);

    async function getOpenPositionsLog() {
        try {
            setIsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/log/open-positions`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200 || !res.data.statusCode) {
                console.log('open-positions', res.data.data)
                setData(res.data.data.logs[0].extras)
                // setSelectedVarietyId(res.data.data.varieties[0]?._id);
            }
            setIsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }

    }


    useEffect(() => {
        getOpenPositionsLog();
        // Set up interval to call the function every 10 seconds
        const interval = setInterval(() => {
            getOpenPositionsLog();
        }, 10000);

        // Cleanup the interval on component unmount
        return () => clearInterval(interval);

    }, []);


    return (
        <React.Fragment>

            <div className="nk-content ">
                <div className="container-fluid select-plan-container">

                    <h1>{"لاگ پوزیشن های باز"}</h1>


                    <div className="spacer"/>
                    <h3>
                        در این صفحه لاگ پوزیشن های باز کاربران قابل مشاهده است
                    </h3>
                    <p>
                        در لیست لاگ معاملات باز، هر کاربر با استفاده از شماره حساب metaapi اش شناخته میشود و در زیر شماره حساب معاملات او نمایش داده میشود. داده های زیر هر ۴۰ ثانیه اپدیت میشوند.
                    </p>



                    <pre className={"log-container"}>
                         {
                             isLoading ? <LoadingState/> :
                                 <code>
                                     {JSON.stringify(data, null, 2)}
                                 </code>
                         }

                    </pre>

                </div>
            </div>
        </React.Fragment>

    );
};

export default OpenPositions;
